export { Property1ArrowUp2 } from "./Property1ArrowUp2";
